/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedBlurbDesignYourOwn_item = {
    readonly isDyoCustomizable: boolean | null;
    readonly " $refType": "PdpSharedBlurbDesignYourOwn_item";
};
export type PdpSharedBlurbDesignYourOwn_item$data = PdpSharedBlurbDesignYourOwn_item;
export type PdpSharedBlurbDesignYourOwn_item$key = {
    readonly " $data"?: PdpSharedBlurbDesignYourOwn_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbDesignYourOwn_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedBlurbDesignYourOwn_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDyoCustomizable",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '3f9d033f1852bd4f72fc01ecdd86894b';
export default node;
